import { useQuery } from '@tanstack/react-query'

import { useAppSelector } from 'common/hooks/redux'

import { fetchMilestoneMetrics } from '../api'
import { contentKeys } from '../queryKeys'

const useGetMilestoneMetricsQuery = () => {
  const accountId = useAppSelector((state) => state.authStates.accountId)

  const getMilestoneMetricsQuery = useQuery({
    queryKey: contentKeys.milestoneMetrics(accountId),
    queryFn: () => fetchMilestoneMetrics(accountId),
    enabled: !!accountId,
  })

  return getMilestoneMetricsQuery
}

export default useGetMilestoneMetricsQuery
